import { ResolveFn } from '@angular/router';
import { inject } from '@angular/core';
import { catchError, finalize, of } from 'rxjs';
import { SpinnerService } from '../services/spinner-service';
import { HttpClientConte } from '../services/http-client-conte';
import { type DettaglioDocumentoI } from '../models/interfaces/documenti-adempimenti/dettaglio-documento.interface';
import { environment } from '../../environments/environment';

export const dettaglioDocumentoResolver: ResolveFn<DettaglioDocumentoI | null> = (route) => {
  const httpClientConte = inject(HttpClientConte);
  const spinnerService = inject(SpinnerService);
  const seqDocumento = Number(
    route.paramMap.get('seqDocumento') ?? route.parent?.paramMap.get('seqDocumento'),
  );

  if (!Number.isFinite(seqDocumento) || seqDocumento <= 0) {
    return of(null);
  }
  const dettaglioEndpoint = `${environment.CONTEXT_DOCUMENTAZIONE}/documenti-adempimenti/${seqDocumento}`;
   // Chiamata mock via server-mock.
  // const dettaglioEndpoint = `${environment.MOCK_API_URL}/documentazione/documenti-adempimenti/${seqDocumento}`;

  spinnerService.enableSpinner();
  return httpClientConte.httpGet<DettaglioDocumentoI>(dettaglioEndpoint).pipe(
    finalize(() => spinnerService.disableSpinner()),
    catchError((error) => {
      console.error('[dettaglioDocumentoResolver] Error fetching dettaglio documento:', error);
      return of(null);
    }),
  );
};
